import React, { useState, useContext } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { LanguageContext } from "../LanguageContext";
import './NavBar.css';
import logo from '../assets/HSM.png';
// import logo from '../assets/blue.png';

const NavBar = ({ onLogoClick }) => {
    const { t, setLanguage } = useContext(LanguageContext);

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [secondMenuOpen, setSecondMenuOpen] = useState(null); // Track which submenu is open
    const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
        setSecondMenuOpen(null); // Close second menu when closing main menu
    };

    const toggleSecondMenu = (menuType) => {
        setSecondMenuOpen(secondMenuOpen === menuType ? null : menuType);
    };

    const toggleLanguageMenu = () => {
        setIsLanguageMenuOpen(!isLanguageMenuOpen);
    };

    const closeLanguageMenu = () => {
        setIsLanguageMenuOpen(false);
    }

    return (
        <>
            <div className="navbar">
                <div className="navbar-left">
                    <div className="roboto-text">
                        <Link to="/" onClick={onLogoClick}>  {/* Add onClick handler */}
                            <img src={logo} alt="Logo" className="navbar-logo" />
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <div className="desktop-nav">
                        <div className="dropdown">
                            <button className="dropbtn dropbtn--clickable" onClick={() => window.location.href = '/about'}>{t("about") || 'About'}</button>
                        </div>
                        <div className="dropdown">
                            <button className="dropbtn">{t("foundations")}
                                <i className="fa fa-caret-down"></i>
                            </button>
                            <div className="dropdown-content">
                                <Link to="/systematics/1">{t("systematics")}I</Link>
                                <Link to="/systematics/2">{t("systematics")}II</Link>
                                <Link to="/systematics/3">{t("systematics")}III</Link>
                                <Link to="/otfoundations">{t("otfoundations")}</Link>
                                <Link to="/ntfoundations">{t("ntfoundations")}</Link>
                                {/* <Link to="/ethics">{t("ethics")}</Link> */}
                            </div>
                        </div>
                        <div className="dropdown">
                            <button className="dropbtn">{t("advanced")}
                                <i className="fa fa-caret-down"></i>
                            </button>
                            <div className="dropdown-content">
                                <Link to="/hebrew">{t("classicalhebrew")}</Link>
                                <a href="/coming-soon">{t("classicalgreek")}</a>
                                <Link to="/latin">{t("classicallatin")}</Link>
                            </div>
                        </div>
                        <div className="dropdown">
                            <button className="dropbtn">{t("classical")}
                                <i className="fa fa-caret-down"></i>
                            </button>
                            <div className="dropdown-content">
                                <a href="/coming-soon">{t("textualcriticism")}</a>
                                <a href="/coming-soon">{t("bibrhet")}</a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Desktop Right Side */}
                <div className="navbar-right desktop-nav">
                    <div className="dropdown">
                        <button className="dropbtn dropbtn--clickable" onClick={() => window.location.href = '/contact'}>{t("schedule")}
                        </button>
                        {/* <div className="dropdown-content">
                            <a
                                href="https://scheduler.zoom.us/halfsermon/exegesis-and-preaching"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="navbar-button"
                            >
                                Zoom
                            </a>
                        </div> */}
                    </div>
                    {/* <div className="roboto-text">
                        <a>{t("give")}</a>
                    </div> */}
                    <div className="dropdown">
                        <button className="dropbtn">{t("languages")}
                            <i className="fa fa-caret-down"></i>
                        </button>
                        <div className="dropdown-content">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                setLanguage("en");
                            }}>
                                English
                            </a>
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                setLanguage("zh-TW");
                            }}>
                                繁體中文
                            </a>
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                setLanguage("zh-CN");
                            }}>
                                简体中文
                            </a>
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                setLanguage("ja");
                            }}>
                                日本語
                            </a>
                        </div>
                    </div>
                </div>

                <div className="mobile-right">
                    {/* Mobile Language Button */}
                    <div className="mobile-language-button" onClick={toggleLanguageMenu}>
                        <svg fill="#0077b6" width="40px" height="40px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                            {/* <title>language icon</title> */}
                            <path d="M478.33,433.6l-90-218a22,22,0,0,0-40.67,0l-90,218a22,22,0,1,0,40.67,16.79L316.66,406H419.33l18.33,44.39A22,22,0,0,0,458,464a22,22,0,0,0,20.32-30.4ZM334.83,362,368,281.65,401.17,362Z" /><path d="M267.84,342.92a22,22,0,0,0-4.89-30.7c-.2-.15-15-11.13-36.49-34.73,39.65-53.68,62.11-114.75,71.27-143.49H330a22,22,0,0,0,0-44H214V70a22,22,0,0,0-44,0V90H54a22,22,0,0,0,0,44H251.25c-9.52,26.95-27.05,69.5-53.79,108.36-31.41-41.68-43.08-68.65-43.17-68.87a22,22,0,0,0-40.58,17c.58,1.38,14.55,34.23,52.86,83.93.92,1.19,1.83,2.35,2.74,3.51-39.24,44.35-77.74,71.86-93.85,80.74a22,22,0,1,0,21.07,38.63c2.16-1.18,48.6-26.89,101.63-85.59,22.52,24.08,38,35.44,38.93,36.1a22,22,0,0,0,30.75-4.9Z" />
                        </svg>
                    </div>

                    {/* Mobile Hamburger Button */}
                    <div className="mobile-menu-button" onClick={toggleMobileMenu}>
                        <div className="hamburger-line"></div>
                        <div className="hamburger-line"></div>
                        <div className="hamburger-line"></div>
                    </div>
                </div>
            </div>


            {/* Language Menu Panel */}
            <div className={`mobile-menu-panel ${isLanguageMenuOpen ? 'open' : ''}`}>
                <div className="mobile-menu-header">
                    <button className="mobile-menu-close" onClick={closeLanguageMenu}>
                        <span><svg
                            className="x-symbol"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            stroke="currentColor"
                        >
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg></span>
                    </button>
                </div>
                <div className="mobile-menu-content">
                    <div className="mobile-menu-section">
                        <h3 className="mobile-menu-title">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                setLanguage("en");
                                closeLanguageMenu();
                            }}>
                                English
                            </a>
                        </h3>
                        <h3 className="mobile-menu-title">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                setLanguage("zh-TW");
                                closeLanguageMenu();
                            }}>
                                繁體中文
                            </a>
                        </h3>
                        <h3 className="mobile-menu-title">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                setLanguage("zh-CN");
                                closeLanguageMenu();
                            }}>
                                简体中文
                            </a>
                        </h3>
                        <h3 className="mobile-menu-title">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                setLanguage("ja");
                                closeLanguageMenu();
                            }}>
                                日本語
                            </a>
                        </h3>
                    </div>
                </div>
            </div>

            {/* Mobile Menu Panel */}
            <div className={`mobile-menu-panel ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="mobile-menu-header">
                    <button className="mobile-menu-close" onClick={closeMobileMenu}>
                        <span><svg
                            className="x-symbol"
                            fill="currentColor"
                            viewBox="0 0 16 16"
                            stroke="currentColor"
                        >
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg></span>
                    </button>
                </div>

                <div className="mobile-menu-content">
                    {/* Home Button */}
                    <div className="mobile-menu-section">
                        <h3 className="mobile-menu-title">
                            <Link to="/" onClick={closeMobileMenu}>{t('home')}</Link>
                        </h3>
                    </div>

                    {/* About Button */}
                    <div className="mobile-menu-section">
                        <h3 className="mobile-menu-title">
                            <Link to="/about" onClick={closeMobileMenu}>{t('about') || 'About'}</Link>
                        </h3>
                    </div>


                    {/* Foundations Section */}
                    <div className="mobile-menu-section">
                        <h3 className="mobile-menu-title" onClick={() => toggleSecondMenu('foundations')}>
                            <a>{t("foundations")}</a>
                        </h3>
                        <div className={`second-menu-panel ${secondMenuOpen === 'foundations' ? 'open' : ''}`}>
                            <div className="second-menu-header">
                                <button className="second-menu-back" onClick={() => setSecondMenuOpen(null)}>
                                    <span>
                                        <svg
                                            className="chevron-back"
                                            fill="none"
                                            viewBox="0 0 16 16"
                                            stroke="currentColor"
                                        >
                                            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                        </svg>
                                    </span>
                                </button>
                                <h3 className="second-menu-main-title">{t("foundations")}</h3>
                                <button className="second-menu-close" onClick={closeMobileMenu}>
                                    <span>
                                        <svg
                                            className="x-symbol"
                                            fill="currentColor"
                                            viewBox="0 0 16 16"
                                            stroke="currentColor"
                                        >
                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                            <div className="second-menu-content">
                                <h3 className="second-menu-title">
                                    <Link to="/systematics/1" onClick={closeMobileMenu}>{t("systematics")} I</Link>
                                </h3>
                                <h3 className="second-menu-title">
                                    <Link to="/systematics/2" onClick={closeMobileMenu}>{t("systematics")} II</Link>
                                </h3>
                                <h3 className="second-menu-title">
                                    <Link to="/systematics/3" onClick={closeMobileMenu}>{t("systematics")} III</Link>
                                </h3>
                                <h3 className="second-menu-title">
                                    <Link to="/otfoundations" onClick={closeMobileMenu}>{t("otfoundations")}</Link>
                                </h3>
                                <h3 className="second-menu-title">
                                    <Link to="/ntfoundations" onClick={closeMobileMenu}>{t("ntfoundations")}</Link>
                                </h3>
                                {/* <h3 className="second-menu-title">
                                    <Link to="/ethics" onClick={closeMobileMenu}>{t("ethics")}</Link>
                                </h3> */}
                            </div>
                        </div>
                    </div>

                    {/* Advanced Section */}
                    <div className="mobile-menu-section">
                        <h3 className="mobile-menu-title" onClick={() => toggleSecondMenu('advanced')}>
                            <a>{t("advanced")}</a>
                        </h3>
                        <div className={`second-menu-panel ${secondMenuOpen === 'advanced' ? 'open' : ''}`}>
                            <div className="second-menu-header">
                                <button className="second-menu-back" onClick={() => setSecondMenuOpen(null)}>
                                    <span>
                                        <svg
                                            className="chevron-back"
                                            fill="none"
                                            viewBox="0 0 16 16"
                                            stroke="currentColor"
                                        >
                                            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                        </svg>
                                    </span>
                                </button>
                                <h3 className="second-menu-main-title">{t("advanced")}</h3>
                                <button className="second-menu-close" onClick={closeMobileMenu}>
                                    <span><svg
                                        className="x-symbol"
                                        fill="currentColor"
                                        viewBox="0 0 16 16"
                                        stroke="currentColor"
                                    >
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                    </svg></span>
                                </button>
                            </div>
                            <div className="second-menu-content">
                                <h3 className="second-menu-title">
                                    <Link to="/hebrew" onClick={closeMobileMenu}>{t("classicalhebrew")}</Link>
                                </h3>
                                <h3 className="second-menu-title">
                                    <a href="/coming-soon" onClick={closeMobileMenu}>{t("classicalgreek")}</a>
                                </h3>
                                <h3 className="second-menu-title">
                                    <Link to="/latin" onClick={closeMobileMenu}>{t("classicallatin")}</Link>
                                </h3>
                            </div>
                        </div>
                    </div>

                    {/* Classical Section */}
                    <div className="mobile-menu-section">
                        <h3 className="mobile-menu-title" onClick={() => toggleSecondMenu('classical')}>
                            <a>{t("classical")}</a>
                        </h3>
                        <div className={`second-menu-panel ${secondMenuOpen === 'classical' ? 'open' : ''}`}>
                            <div className="second-menu-header">
                                <button className="second-menu-back" onClick={() => setSecondMenuOpen(null)}>
                                    <span>
                                        <svg
                                            className="chevron-back"
                                            fill="none"
                                            viewBox="0 0 16 16"
                                            stroke="currentColor"
                                        >
                                            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                        </svg>
                                    </span>
                                </button>
                                <h3 className="second-menu-main-title">{t("classical")}</h3>
                                <button className="second-menu-close" onClick={closeMobileMenu}>
                                    <span><svg
                                        className="x-symbol"
                                        fill="currentColor"
                                        viewBox="0 0 16 16"
                                        stroke="currentColor"
                                    >
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                    </svg></span>
                                </button>
                            </div>
                            <div className="second-menu-content">
                                <h3 className="second-menu-title">
                                    <a href="/coming-soon" onClick={closeMobileMenu}>{t("textualcriticism")}</a>
                                </h3>
                                <h3 className="second-menu-title">
                                    <a href="/coming-soon" onClick={closeMobileMenu}>{t("bibrhet")}</a>
                                </h3>
                            </div>
                        </div>
                    </div>

                    {/* Contact Button */}
                    <div className="mobile-menu-section">
                        <h3 className="mobile-menu-title">
                            <Link to="/contact" onClick={closeMobileMenu}>{t('schedule')}</Link>
                        </h3>
                    </div>

                    {/* Give Section */}
                    <div className="mobile-menu-section">
                        {/* <h3 className="mobile-menu-title">
                            <a href="#" onClick={closeMobileMenu}>{t("give")}</a>
                        </h3> */}
                        {/* <button className="give-button">
                            <a
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t("give")}
                            </a>
                        </button> */}
                    </div>
                </div>
            </div>

            {/* Overlay for mobile menu */}
            {isMobileMenuOpen && (
                <div className="mobile-menu-overlay" onClick={closeMobileMenu}></div>
            )}

            {/* Overlay for language menu */}
            {isLanguageMenuOpen && (
                <div className="mobile-menu-overlay" onClick={closeLanguageMenu}></div>
            )}
        </>
    );
};

export default NavBar;